import { render, staticRenderFns } from "./ArtistList.vue?vue&type=template&id=2c1ef747&scoped=true&"
import script from "./ArtistList.vue?vue&type=script&lang=js&"
export * from "./ArtistList.vue?vue&type=script&lang=js&"
import style0 from "./ArtistList.vue?vue&type=style&index=0&id=2c1ef747&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1ef747",
  null
  
)

export default component.exports